module.exports = __webpack_public_path__ + "static/media/icon_event_red_card.cd6d9223.svg";